module.exports = __webpack_public_path__ + "img/bg-signin.ed373d3e.jpg";